import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LinkComponent } from '../../atoms/link/link.component';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Colors, Sizes } from '../../../shared/enums/shared.enums';
import { HrefType } from '../../../shared/enums/href-type.enums';
import LinkType from '../../../shared/enums/link-type.enums';
import ViewportType from '../../../shared/enums/viewport-type.enums';
import { Breadcrumbs } from '../../../shared/interfaces/navigation-page.interface';

@Component({
  selector: 'hdi-breadcrumbs',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, LinkComponent, IconComponent],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class BreadcrumbsComponent {
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() breadcrumbs: Breadcrumbs[] = [];

  breadcrumbType = LinkType.BREADCRUMB;
  breadcrumbNoIconType = LinkType.BREADCRUMB_NO_ICON;
  Colors = Colors;
  Sizes = Sizes;
  BreadcrumbHrefType = HrefType;
}
